<template>
    <div>
        <h1 class="card-title h5">{{ $t('common.dear_guest') }}</h1>

        <div>
            <template v-if="activationData.externalVoucherDownload">
                <i18n path="externalBooking.urlBooking.externalDownloadText" tag="p" class="card-text">
                    <span slot="booking_service_name">{{ activationData.bookingServiceName }}</span>
                </i18n>
            </template>
            <template v-else>
              <i18n path="nonHotelVoucherForm.intro" tag="p" class="card-text">
                <mark slot="hotelname">{{ activationData.arrangement.hotelname }}</mark>
              </i18n>

              <p class="card-text"><mark>{{ codeToUse }}</mark></p>
            </template>

          <p class="card-text">
            {{ $t('externalBooking.urlBooking.externalDurationText') }}
          </p>

            <transition name="fade">
                <ContactForm v-if="showVoucherInfoForm"
                             :submit-text="$t('sendVoucherInfo.action.generic.submit.text')"
                             :is-sending="isSendingData"
                             :showNewsletterCheckbox="showNewsletterCheckbox"
                             :sendVoucher="true"
                             @submit="sendVoucherInfo">
                    <template v-slot:before>
                        <p class="card-text">
                            {{ $t('sendVoucherInfo.supporting_text.common.form_intro') }}
                        </p>
                    </template>

                    <template v-slot:after>
                        <GdprNotice/>
                    </template>
                </ContactForm>
            </transition>

            <div class="card-navigation justify-content-center justify-content-md-between align-items-start flex-wrap">
                <button type="button" class="btn btn-secondary mb-3 mb-md-0" @click="$store.dispatch('reset')">
                    {{ $t('common.redeem_another_voucher') }}
                </button>

                <a v-if="activationData.bookingServiceUrl" :href="activationData.bookingServiceUrl" class="btn btn-primary"
                   target="_blank" rel="nofollow">
                    {{
                        $t('externalBooking.urlBooking.goToBookingPage')
                    }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import CustomerServiceBlock from './CustomerServiceBlock'
import CustomerServiceEmail from './CustomerServiceEmail'
import CustomerServicePhone from './CustomerServicePhone'
import ErrorMessages from '../components/ErrorMessages'
import GdprNotice from '../components/GdprNotice'
import ContactForm from '@/components/ContactForm'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'NonHotelVoucherForm',
    components: {
        CustomerServiceEmail,
        CustomerServiceBlock,
        CustomerServicePhone,
        ErrorMessages,
        GdprNotice,
        ContactForm
    },
    data () {
        return {
            errors: [],
            isVoucherInfoFormSubmitted: false,
            isPersonalInfoFormSubmitted: false,
            isSendingData: false,
            firstname: '',
            lastname: '',
            email: '',
            placeholder_firstname: this.$i18n.t('generic.firstname'),
            placeholder_lastname: this.$i18n.t('generic.lastname'),
            placeholder_email: this.$i18n.t('generic.email'),
            showNewsletterCheckbox: true
        }
    },
    computed: {
        ...mapState(['voucher', 'activationData']),
        ...mapGetters(['voucherCode']),
        showVoucherInfoForm () {
            return !this.isVoucherInfoFormSubmitted
        },
        bookingServiceEmailLink () {
            return 'mailto:' + this.activationData.bookingServiceEmail
        },
        codeToUse() {
            return this.activationData.externalVoucherCode || this.voucherCode
        }
    },
    methods: {
        async sendVoucherInfo (contactData) {
            try {
              this.isSendingData = true
              const {successful} = await this.$store.dispatch('sendVoucherDataRequest', {
                ...contactData,
                voucherCode: this.voucherCode
              })
              //this.isVoucherInfoFormSubmitted = successful @AG: please have a look - successful is undefined. Using 'true' now as a workaround
              this.isVoucherInfoFormSubmitted = true
            } finally {
              this.isSendingData = false
            }
        }
    }
}
</script>
<style lang="scss" scoped >
@use "@/styles/_variables";
@use "sass:map";

.avp-text-highlight {
    background-color: rgba(#fff, 1);
    color: map.get(variables.$colors, 'secondary');
}

mark {
    display: block;
    background: transparent;
    color: hsl(0, 0%, 0%);
    font-size: 18px;
    padding: 0 0.3125rem;
    text-align: center;
    font-family: "Courier New", monospace, serif;
    font-weight: bold;
}

.avp-form-button-row {
    padding: 0 5px;
    justify-content: center;

    button {
        margin: 0 .375rem;
    }

    @media (max-width: 575px) {
        flex-wrap: wrap-reverse;
    }
}
</style>
